import React from 'react'
import { graphql, Link } from 'gatsby'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import Img from 'gatsby-image'
const axios = require('axios')
import Layout from '../../../components/layout'
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
} from 'reactstrap'
import header from '../../../images/CleanAir-Desktop-Header-1920x340-Curve-DataHub-2x.png'
import headerMobile from '../../../images/CleanAir-Mobile-Header-1080x550-Curve-DataHub-2x.png'
import LinkBack from '../../../components/link-back'

class UnsubscribeTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      step: 'form',
      email: '',
      phone_number: '',
      code: '',
      token: null,
      sentTo: null,
      error: false,
      message: null,
      submitting: false,
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleVerify = this.handleVerify.bind(this)
  }

  handleInputChange(event) {
    const target = event.target
    const value = target.value
    const name = target.name
    this.setState({
      [name]: value,
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    const email = (this.state.email || '').trim()
    const phone = (this.state.phone_number || '').trim()
    if (!email && !phone) {
      this.setState({
        error: true,
        message: 'Please provide an email address or phone number.',
      })
      return
    }
    if (email && phone) {
      this.setState({
        error: true,
        message:
          'Please provide either an email address or a phone number, not both.',
      })
      return
    }

    this.setState({ submitting: true, error: false, message: null })
    axios
      .post('/.netlify/functions/unsubscribe', {
        action: 'start',
        email,
        phone_number: phone,
      })
      .then(response => {
        if (response.data.status === 200) {
          this.setState({
            step: 'verify',
            token: response.data.token,
            sentTo: response.data.sentTo,
            submitting: false,
          })
          return
        }
        this.setState({
          error: true,
          message:
            response.data.message ||
            'An error has occurred, please try again later.',
          submitting: false,
        })
      })
      .catch(err => {
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          'An error has occurred, please try again later.'
        this.setState({ error: true, message, submitting: false })
      })
  }

  handleVerify(event) {
    event.preventDefault()
    this.setState({ submitting: true, error: false, message: null })
    axios
      .post('/.netlify/functions/unsubscribe', {
        action: 'verify',
        token: this.state.token,
        code: this.state.code,
      })
      .then(response => {
        if (response.data.status === 200) {
          this.setState({ step: 'success', submitting: false })
          return
        }
        this.setState({
          error: true,
          message:
            response.data.message ||
            'An error has occurred, please try again later.',
          submitting: false,
        })
      })
      .catch(err => {
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          'An error has occurred, please try again later.'
        this.setState({ error: true, message, submitting: false })
      })
  }

  render() {
    const post = get(this.props, 'data.contentfulBasicPage')
    const siteTitle = get(this.props, 'data.site.siteMetadata.title')

    return (
      <Layout location={this.props.location}>
        <div style={{ background: '#fff' }}>
          <Helmet title={`Unsubscribe from alerts | ${siteTitle}`} />

          <div className="page-banner page-banner--disclaimer">
            <img className="d-none d-lg-block" src={header} alt="" />
            <img className="d-block d-lg-none" src={headerMobile} alt="" />
            <h1>Unsubscribe from alerts</h1>
          </div>

          <Container className="news mb-5">
            <LinkBack
              to={'/data-hub/forecast-and-alerts'}
              title={'back to Forecast and alerts'}
            />
            <Row>
              <Col>
                <p>
                  You can unsubscribe at any time by completing the form below.
                </p>
              </Col>
            </Row>
          </Container>

          <div className="subscribe-form pt-5 pb-5 mt-5">
            <Container>
              {this.state.step === 'form' && (
                <Form onSubmit={this.handleSubmit}>
                  <FormGroup>
                    <Label for="email">Email</Label>
                    <Input
                      type="text"
                      name="email"
                      id="email"
                      value={this.state.email}
                      onChange={this.handleInputChange}
                    ></Input>
                  </FormGroup>
                  <p>
                    <b>Or</b>
                  </p>
                  <FormGroup>
                    <Label for="phone_number">Phone number</Label>
                    <Input
                      type="text"
                      name="phone_number"
                      id="phone_number"
                      value={this.state.phone_number}
                      onChange={this.handleInputChange}
                    ></Input>
                  </FormGroup>
                  {this.state.error && (
                    <Alert color="danger">{this.state.message}</Alert>
                  )}
                  <button
                    className="btn btn-content"
                    type="submit"
                    disabled={this.state.submitting}
                  >
                    {this.state.submitting ? 'Sending...' : 'Submit'}
                  </button>
                </Form>
              )}
              {this.state.step === 'verify' && (
                <Form onSubmit={this.handleVerify}>
                  <p>
                    We've sent a 6-digit verification code to{' '}
                    <b>{this.state.sentTo}</b>. Enter it below to confirm your
                    unsubscription. The code expires in 10 minutes.
                  </p>
                  <FormGroup>
                    <Label for="code">Verification code *</Label>
                    <Input
                      type="text"
                      name="code"
                      id="code"
                      inputMode="numeric"
                      pattern="[0-9]{6}"
                      maxLength="6"
                      autoComplete="one-time-code"
                      value={this.state.code}
                      onChange={this.handleInputChange}
                      required
                    />
                  </FormGroup>
                  {this.state.error && (
                    <Alert color="danger">{this.state.message}</Alert>
                  )}
                  <button
                    className="btn btn-content"
                    type="submit"
                    disabled={this.state.submitting}
                  >
                    {this.state.submitting ? 'Verifying...' : 'Confirm'}
                  </button>
                </Form>
              )}
              {this.state.step === 'success' && (
                <div>
                  <h2>Success</h2>
                  <p>You have successfully unsubscribed</p>
                </div>
              )}
            </Container>
          </div>
        </div>
      </Layout>
    )
  }
}

export default UnsubscribeTemplate

export const pageQuery = graphql`
  query UnsubscribePageBySlug {
    site {
      siteMetadata {
        title
      }
    }
  }
`
